import { css } from '@emotion/react'
import { graphql } from 'gatsby'
import { ComponentPropsWithoutRef } from 'react'

import { DatoStructuredText } from '@/features/common'
import { mq } from '@/theme/mixins'
import { colors } from '@/theme/variables'

import { Form } from './Form/Form'

interface Props extends ComponentPropsWithoutRef<'article'> {
  data?: Queries.FormLightboxFragment | null
  layout: 'LIGHTBOX' | 'PAGE'
}

export const FormLightbox = ({ data, layout, ...props }: Props) => {
  const styles = {
    article: css`
      width: calc(100vw - 4 * var(--margin));
      ${mq().s} {
        width: calc(100vw - 2 * var(--margin) - 1.5rem);
      }
      ${layout === 'LIGHTBOX' &&
      css`
        padding: var(--row-72) var(--margin);
        max-width: 65ch;
      `}
      ${layout === 'PAGE' &&
      css`
        padding: var(--row-108) var(--margin);
        background: #fff;
        max-width: 70ch;
      `}
    `,
    heading: css`
      font-size: var(--fs-48);
      margin: 0 0 0.333em;
      text-align: center;
      font-weight: 600;
    `,
    body: css`
      text-align: center;
    `,
    form: css`
      margin-top: 2em;
      padding-top: 1.5em;
      border-top: 1px solid ${colors.gray90};
    `,
  }
  return (
    <article
      css={styles.article}
      {...props}
    >
      <h1 css={styles.heading}>{data?.heading}</h1>
      <div css={styles.body}>
        <DatoStructuredText data={data?.body} />
      </div>
      <Form
        css={styles.form}
        data={data?.form}
      />
    </article>
  )
}

export const FormLightboxFragment = graphql`
  fragment FormLightbox on DatoCmsFormLightbox {
    __typename
    id: originalId
    heading
    body {
      value
    }
    form {
      ...Form
    }
    slug
    seoMetaTags {
      tags
    }
  }
`
